import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import React from "react";

import { useSelector } from "react-redux";
import useHymns from "../../../hooks/useHyms";
import useInput from "../../../hooks/useInput";
import { validators } from "../../../utilities/inputValidator";
import FormDesCription from "../formDescription/form-description";
import Spinner from "../spinner/spinner";
import classes from "./formDialog.module.css";

const FormDialog = () => {
   const {
      hymns: { hymn, openForm, createLoading },
   } = useSelector((state) => state);

   const { closeHymnsForm, addHymn } = useHymns();

   const {
      value: hymnTitle,
      valueInputChange: hymnTitleInputChange,
      valueIsValid: titleIsValid,
      hasError: titleHasError,
      inputBlurHandler: titleBlurHandler,
   } = useInput(validators.checkValueIsEmpty, `${hymn.hymnTitle ?? ""}`);
   const {
      value: hymnDescription,
      setQuillValue: descruptionInputChange,
      valueIsValid: descriptionIsValid,
   } = useInput(validators.checkValueIsEmpty, `${hymn.hymnDescription ?? ""}`);

   const {
      value: author,
      valueInputChange: authorInputChange,
      valueIsValid: authorIsValid,
      hasError: authorHasError,
      inputBlurHandler: authorBlurHandler,
   } = useInput(validators.checkValueIsEmpty, `${hymn.author ?? ""}`);

   const {
      value: hymnNumber,
      valueInputChange: numberInputChange,
      valueIsValid: numberIsValid,
      hasError: numberHasError,
      inputBlurHandler: numberBlurHandler,
   } = useInput(validators.minValue, +`${hymn.hymnNumber ?? 0}`);

   const formIsValid =
      numberIsValid && descriptionIsValid && titleIsValid && authorIsValid;

   const onAddhymn = () => {
      if (!formIsValid) {
         return;
      }

      const reqBody = {
         hymnTitle,
         hymnNumber,
         author,
         hymnDescription,
      };
      if (hymn.id) {
         reqBody.id = hymn.id;
      }

      addHymn(reqBody);
   };

   return (
      <Dialog open={openForm} onClose={closeHymnsForm} onBackdropClick={null}>
         <DialogTitle>Hymns</DialogTitle>
         <DialogContent>
            <TextField
               autoFocus
               margin="dense"
               id="name"
               label="Hymn number"
               type="number"
               fullWidth
               variant="outlined"
               value={hymnNumber}
               onChange={numberInputChange}
               onBlur={numberBlurHandler}
               error={numberHasError}
            />
            <TextField
               margin="dense"
               id="name"
               label="Hymn Title"
               type="text"
               fullWidth
               variant="outlined"
               value={hymnTitle}
               onChange={hymnTitleInputChange}
               onBlur={titleBlurHandler}
               error={titleHasError}
            />

            <FormDesCription
               inputChange={descruptionInputChange}
               value={hymnDescription}
            />

            <TextField
               margin="dense"
               id="name"
               label="author"
               type="text"
               fullWidth
               variant="outlined"
               value={author}
               onChange={authorInputChange}
               onBlur={authorBlurHandler}
               error={authorHasError}
            />
         </DialogContent>
         <DialogActions>
            <Button onClick={closeHymnsForm}>Cancel</Button>
            <Button
               className={classes.button}
               variant="contained"
               disabled={!formIsValid}
               onClick={onAddhymn}
            >
               Save
            </Button>
         </DialogActions>

         {createLoading && <Spinner />}
      </Dialog>
   );
};

export default FormDialog;
